import { VisitNodePassage } from "../../../types";
export const description = (params) => (args) => {
    if (args.context.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    const element = args.visitable;
    const measures = element?.data ? element?.data[0].measures : element.measures;
    const data = {
        imageUrl: measures?.[params[0].imageUrlField],
        text: measures?.[params[0].textField]
    };
    data.imageIsExternalContent = data.imageUrl?.startsWith("http");
    args.context.staticData.customResult = [data];
};
